import { c as _c } from "react/compiler-runtime";
import { useAppParams } from "@router/router-helper";
import { companyMemberGroupsSelector, companyMemberGroupsStatusSelector } from "@store/company-member-groups/company-member-groups-selector";
import { resetCompanyMemberGroupsState } from "@store/company-member-groups/company-member-groups-slice";
import { fetchCompanyMemberGroups } from "@store/company-member-groups/company-member-groups-thunk";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { useEffect } from "react";
/** Fetches the groups of a company member */
export function useMemberGroups() {
  const $ = _c(8);
  const dispatch = useAppDispatch();
  const {
    memberId,
    teamId
  } = useAppParams();
  const groups = useAppSelector(companyMemberGroupsSelector);
  const companyMemberGroupsStatus = useAppSelector(companyMemberGroupsStatusSelector);
  let t0;
  let t1;
  if ($[0] !== dispatch || $[1] !== memberId || $[2] !== teamId) {
    t0 = () => {
      const id = memberId || teamId;
      if (id) {
        dispatch(fetchCompanyMemberGroups({
          memberId: id
        }));
      }
      return () => {
        dispatch(resetCompanyMemberGroupsState());
      };
    };
    t1 = [dispatch, memberId, teamId];
    $[0] = dispatch;
    $[1] = memberId;
    $[2] = teamId;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
  let t2;
  if ($[5] !== companyMemberGroupsStatus || $[6] !== groups) {
    t2 = {
      groups,
      companyMemberGroupsStatus
    };
    $[5] = companyMemberGroupsStatus;
    $[6] = groups;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}